const state = {
  userInfo: {},
  pageTitle: '',
  loginStatus: sessionStorage.getItem('loginStatus') || '1',
  userName: sessionStorage.getItem('userInfo') || ''

}
export default state



// WEBPACK FOOTER //
// ./src/vuex/modules/user/state.js